import React from 'react';

import * as pages from 'pages';
import * as paths from './const';
import { ROUTE_WEATHER_TODAY_WEATHER } from './const';
interface RouteProps {
  path: string;
  component: React.LazyExoticComponent<React.ComponentType<any>>;
}

interface RoutesProps {
  public: RouteProps[];
  common: RouteProps[];
  MASTER_ADMIN: RouteProps[];
  SITE_ADMIN: RouteProps[];
  CONSTRUCTOR: RouteProps[];
  SUB_CONSTRUCTOR: RouteProps[];
  [key: string]: RouteProps[];
}

/** 공통으로 사용되는 대시보드 라우트 */
const commonDashboardRoutes: RouteProps[] = [
  {
    path: paths.ROUTE_CHART_DASHBOARD,
    component: pages.LazyDashboardChart
  },
  {
    path: paths.ROUTE_3D_DASHBOARD,
    component: pages.LazyDashboard3d
  }
];

/** 공통으로 사용되는 프로젝트/회사 관리 라우트 */
const commonManagementRoutes: RouteProps[] = [
  { path: paths.ROUTE_PJT, component: pages.LazyProjectInformationPage },
  { path: paths.ROUTE_COMPANY, component: pages.LazyCompanyPage }
];

export const routes: RoutesProps = {
  public: [
    { path: paths.ROUTE_SIGN_IN, component: pages.LazySignInPage },
    { path: paths.ROUTE_PTW_PREVIEW, component: pages.LazyPtwPreviewPage }
  ],
  common: [
    { path: paths.ROUTE_ROOT, component: pages.LazyHomePage },
    { path: paths.ROUTE_NOTICE, component: pages.LazyNoticePage },
    {
      path: paths.ROUTE_USER_ADMINISTRATOR_MANAGEMENT,
      component: pages.LazyAdministratorManagementListsPage
    },
    {
      path: paths.ROUTE_USER_FRS_MANAGEMENT,
      component: pages.LazyFrsManagementListsPage
    },
    {
      path: paths.ROUTE_USER_WORKER_MANAGEMENT,
      component: pages.LazyWorkerManagementListsPage
    },
    {
      path: paths.ROUTE_PASSPORT_SITE_ENTRY_MANAGEMENT,
      component: pages.LazySiteEntryManagementPage
    },
    {
      path: paths.ROUTE_PASSPORT_SAFETY_TRAINING,
      component: pages.LazySafetyTrainingListsPage
    },
    {
      path: paths.ROUTE_PASSPORT_SITE_ENTRY_HISTORY,
      component: pages.LazySiteEntryHistoryPage
    },
    {
      path: paths.ROUTE_ENVIRONMENT_CURRENT,
      component: pages.LazyEnvironment
    },
    {
      path: paths.ROUTE_ENVIRONMENT_HISTORTY,
      component: pages.LazyEnvironmentHistory
    },

    // SAMSUNG 전용
    {
      path: paths.ROUTE_TBM_STATUS,
      component: pages.LazyTbmStatusPage
    },
    {
      path: paths.ROUTE_TBM_ATTENDANCE,
      component: pages.LazyTbmAttendancePage
    },
    {
      path: paths.ROUTE_TBM_MONITORING,
      component: pages.LazyTbmMonitoringPage
    },
    //PTW
    {
      path: paths.ROUTE_PTW_MY_ISSUE,
      component: pages.LazyPtwMyIssuePage
    },
    {
      path: paths.ROUTE_PTW_MY_APPROVAL,
      component: pages.LazyPtwMyApprovalPage
    },
    {
      path: paths.ROUTE_PTW_STATUS,
      component: pages.LazyPtwStatusPage
    },
    {
      path: paths.ROUTE_PTW_SETTING,
      component: pages.LazyPtwSettingPage
    },
    //IOT
    {
      path: paths.ROUTE_IOT_DEVICE,
      component: pages.LazyIotDevicePage
    },
    {
      path: paths.ROUTE_IOT_DISTRIBUTE,
      component: pages.LazyIotDistributePage
    },
    {
      path: paths.ROUTE_IOT_ENV_SENSOR,
      component: pages.LazyEnvSensorPage
    },
    {
      path: paths.ROUTE_IOT_ALTER_HISTORY,
      component: pages.LazyAlterHistoryPage
    },
    //HEAVY Equipment
    {
      path: paths.ROUTE_HEAVY_MANAGEMENT,
      component: pages.LazyHeManagementPage
    },
    {
      path: paths.ROUTE_HEAVY_APPROVAL,
      component: pages.LazyHeApprovalPage
    },
    {
      path: paths.ROUTE_HEAVY_SETTING,
      component: pages.LazyHeSettingPage
    },
    // TBM Management
    {
      path: paths.ROUTE_TBM_MANAGEMENT,
      component: pages.LazyTbmManagementPage
    },
    //Weather Air Quality
    {
      path: paths.ROUTE_WEATHER_TODAY_WEATHER,
      component: pages.LazyTodayWeatherPage
    },
    {
      path: paths.ROUTE_WEATHER_WEATHER_HISTORY,
      component: pages.LazyWeatherHistoryPage
    },
    {
      path: paths.ROUTE_WEATHER_LIGHTNING_HISTORY,
      component: pages.LazyLightningHistoryPage
    },
  ],
  MASTER_ADMIN: [
    ...commonDashboardRoutes,
    ...commonManagementRoutes,
    {
      path: paths.ROUTE_USER_APPROVAL,
      component: pages.LazyUserApprovalListPage
    },
    {
      path: paths.ROUTE_PASSPORT_TRAINING_SETTING,
      component: pages.LazySafetyTrainingSettingPage
    },
    {
      path: paths.ROUTE_SYSTEM_SETTING,
      component: pages.LazySystemSettingPage
    },
    {
      path: paths.ROUTE_SYSTEM_DASHBOARD,
      component: pages.LazySystemDashboardPage
    }
  ],
  SITE_ADMIN: [
    ...commonDashboardRoutes,
    ...commonManagementRoutes,
    {
      path: paths.ROUTE_USER_APPROVAL,
      component: pages.LazyUserApprovalListPage
    },
    {
      path: paths.ROUTE_PASSPORT_TRAINING_SETTING,
      component: pages.LazySafetyTrainingSettingPage
    },
    {
      path: paths.ROUTE_SYSTEM_SETTING,
      component: pages.LazySystemSettingPage
    },
    {
      path: paths.ROUTE_SYSTEM_DASHBOARD,
      component: pages.LazySystemDashboardPage
    }
  ],
  CONSTRUCTOR: [...commonDashboardRoutes, ...commonManagementRoutes],
  SUB_CONSTRUCTOR: [...commonDashboardRoutes, ...commonManagementRoutes]
};
